const htmlEntities = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: " ",
    quot: '"',
};

export function decodeHtmlEntities(value) {
    if (typeof value !== "string") return "";

    return value.replace(/&(#x[\da-f]+|#\d+|[a-z]+);/gi, (entity, code) => {
        const normalizedCode = code.toLowerCase();

        if (normalizedCode.startsWith("#x")) {
            const charCode = Number.parseInt(normalizedCode.slice(2), 16);
            return Number.isNaN(charCode) ? entity : String.fromCodePoint(charCode);
        }

        if (normalizedCode.startsWith("#")) {
            const charCode = Number.parseInt(normalizedCode.slice(1), 10);
            return Number.isNaN(charCode) ? entity : String.fromCodePoint(charCode);
        }

        return htmlEntities[normalizedCode] ?? entity;
    });
}

export function getSerializedBuilderData(value) {
    if (typeof value !== "string") {
        return undefined;
    }

    const trimmed = value.trim();
    if (!trimmed || trimmed === "{}") {
        return undefined;
    }

    const candidates = [trimmed, decodeHtmlEntities(trimmed)];

    for (const candidate of candidates) {
        try {
            JSON.parse(candidate);
            return candidate;
        } catch {
            // Try the next decoded form.
        }
    }

    return undefined;
}

export function parseSerializedBuilderData(value) {
    const serialized = getSerializedBuilderData(value);
    if (!serialized) return undefined;

    try {
        return JSON.parse(serialized);
    } catch {
        return undefined;
    }
}
